













import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class AppPicture extends Vue {
  /// exp: 3 / 2
  @Prop({ type: String, default: 'auto' })
  readonly ratio!: string;

  @Prop({ type: String, default: 'cover' })
  readonly fitMode!: 'cover' | 'fill' | 'contain';

  @Prop({ type: String, default: '' })
  readonly image!: string;

  @Prop({ type: String, default: 'Изображение без названия' })
  readonly alt!: string;

  @Prop({ type: Boolean, default: false })
  readonly isShowOnerrorImg!: boolean;

  @Prop({ type: String, default: '100%' })
  readonly imageHeight: string;

  @Prop({ type: String, default: '100%' })
  readonly imageWidth: string;

  @Prop({ type: String, default: '0' })
  readonly borderRadius: string;

  @Prop({ type: String, default: '#efefef' })
  readonly backgroundColor: string;

  srcImg = this.image;

  get onErrImage() {
    return './assets/img_not_available.jpg';
  }

  get rootStyle() {
    return {
      '--fit-mode': this.fitMode,
      '--ratio': this.ratio,
      '--picture-border-radius': this.borderRadius,
      '--picture-background-color': this.backgroundColor,
    };
  }

  setErrImg() {
    this.srcImg = require(`${this.onErrImage}`);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppPicture/AppPicture.vue